module.exports = __webpack_public_path__ + "img/tk.0f5651ed.png";